import {
  ProjectSelect,
  ProjectSelectLegacy,
  Props as ProjectSelectProps,
} from '@/components/ProjectSelect';
import { PaymentRequestForm } from '@/features/InvoiceReport/Edit/type';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { memo, useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { CellProps } from './type';

type Props<TFieldValues extends PaymentRequestForm> =
  ProjectSelectProps<TFieldValues> & CellProps;

const InnerProjectSelectCell = <TFieldValues extends PaymentRequestForm>({
  index,
  ...props
}: Props<TFieldValues>) => {
  const cacheKey = useMemo(() => ['row', 'project', index], [index]);
  const { setValue } = useFormContext<PaymentRequestForm>();

  const useProjectSelectById = useBooleanFlagValue(
    'use-project-select-for-report-form',
    false
  );
  const SelectComponent = useProjectSelectById
    ? ProjectSelect
    : ProjectSelectLegacy;

  const setLabelField = useCallback(
    (labelFieldValue: string) => {
      setValue(
        useProjectSelectById
          ? `invoiceTransactions.${index}.projectName`
          : `invoiceTransactions.${index}.projectCodeName`,
        labelFieldValue
      );
    },
    [setValue, index, useProjectSelectById]
  );

  return (
    <SelectComponent<TFieldValues>
      per={500}
      cacheQueryKey={cacheKey}
      {...props}
      setLabelField={setLabelField}
    />
  );
};
InnerProjectSelectCell.displayName = 'InnerProjectSelectCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const ProjectSelectCell = memo(
  InnerProjectSelectCell
) as typeof InnerProjectSelectCell;
ProjectSelectCell.displayName = 'ProjectSelectCell';
